'use strict';


import { Quaternion, Spherical, Vector3 } from 'three';
import { BaseElement } from '../../../interfaces/BaseElement';
import { GSAPAnimationMixer, threeJsVariables, TRoot } from '../../../../settings';
import { Lerp } from '../../../projectTime/Lerp';
import gsap from "gsap";
import { TilesPluginCore } from './TilesPluginCore';

export class BuildingsHomeLabelPlugin extends TilesPluginCore{
	constructor (panorama) {
		super('BuildingsHomeLabelPlugin');
		
		this.panorama = panorama;
		this.direction = new Vector3().fromArray(this.panorama.config.panorama.target).normalize();
		
		this.tempDirection = new Vector3();
		this._camDirection = new Vector3();
		this.camQuaternion = new Quaternion();
		this.spherical = new Spherical().setFromVector3(this.direction);
		
		this.position = new Vector3()
			.fromArray(this.panorama.config.panorama.position)
			.sub(new Vector3().setFromSphericalCoords(this.panorama.config.size,this.spherical.phi,this.spherical.theta));
		
		this.homeLabel = null;
		this.homeLabelDirection = null;
		
		this.#createLabel();
	}
	
	#createLabel() {
		this.homeLabel = new BaseElement()
			.addClass('air-mode__home-label')
			.event('click',this.#returnToHome.bind(this))
			.DOMElement;
		
		new BaseElement()
			.addClass('air-mode__home-label__icon','icon-home2')
			.appendTo(this.homeLabel);
		
		this.homeLabelDirection = new BaseElement()
			.addClass('air-mode__home-label__direction')
			.appendTo(this.homeLabel)
			.DOMElement;
		
		new BaseElement()
			.addClass('air-mode__home-label__direction__icon','icon-up2')
			.appendTo(this.homeLabelDirection);
		
		const awaitBottomNavBar = setInterval(() => {
			if (document.querySelector('.bottom__nav-bar')) {
				clearInterval(awaitBottomNavBar);
				document.querySelector('.bottom__nav-bar').appendChild(this.homeLabel);
			}
		},1000);
	}
	
	#getDelta() {
		const from = this.panorama.controls.getAzimuthalAngle();
		const to = this.spherical.theta;
		
		const tempD = to - from;
		let delta;
		
		if (tempD < 0 && tempD < -Math.PI) {
			delta = tempD + 2 * Math.PI;
		} else if (tempD > 0 && tempD > Math.PI) {
			delta = tempD - 2 * Math.PI;
		} else {
			delta = tempD;
		}
		
		return delta;
	}
	
	#returnToHome() {
		const delta = this.#getDelta();
		const from = this.panorama.controls.getAzimuthalAngle();
		const theta = new Lerp(from,from + delta );
		const phi = new Lerp(this.panorama.controls.getPolarAngle(),this.spherical.phi);
		
		const progress = {
			value: 0
		};
		
		gsap.to(progress,{
			value: 1,
			duration: GSAPAnimationMixer.duration,
			ease: GSAPAnimationMixer.ease,
			onUpdate: () => {
				this.panorama.controls.setAzimuthAngle(theta.lerp(progress.value));
				this.panorama.controls.setPolarAngle(phi.lerp(progress.value));
			}
		});
	}
	
	update(frustum) {
		this._camDirection.copy(this.panorama.camera.position).sub(this.panorama.controls.target).normalize();
		
		if (this.direction.distanceTo(this._camDirection) >= 0.25) {
			
			if (frustum.containsPoint(this.position)) {
				this.homeLabelDirection.style.display = `none`;
			} else {
				this.panorama.camera.getWorldQuaternion(this.camQuaternion);
				this.tempDirection.copy(this.direction);
				this.tempDirection.applyQuaternion(this.camQuaternion.invert());
				const rotationAngle = Math.atan2(-this.tempDirection.x, -this.tempDirection.y);
				this.homeLabelDirection.style.transform = `translate(-50%, -50%) rotate(${rotationAngle}rad)`;
				this.homeLabelDirection.style.display = ``;
			}
			
			this.homeLabel.style.display = '';
		} else {
			this.homeLabel.style.display = 'none';
		}
	}
	
	disable () {
		this.dispose();
	}
	
	enable () {
		if (this.homeLabel && document.querySelector('.bottom__nav-bar')) {
			document.querySelector('.bottom__nav-bar').appendChild(this.homeLabel);
		}
	}
	
	dispose() {
		this.homeLabel.remove();
	}
}
